import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';
import { ZebraPrintDocumentDto } from './ZebraPrintDocumentDto'

export class ZebraPrinterStatusDto extends BaseBus {
    constructor(data: ZebraPrinterStatusDto) {
        super(data);
    }
    CID(): any {
        return this.zebraPrinterId;
    }
    setId(id: any) {
        this.zebraPrinterId = id;
    }
    zebraPrinterId: any;
    printerDisplayName: string;
    printerDesc: string;
    printerSerialNbr: string;
    lastOnlineDt: Date;
    isAvailable: boolean;
    printerErrorStates: any;
    hostName: string;
    isEnabled: boolean;
    documentQueue: ZebraPrintDocumentDto[];

}
